import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  IconButton,
  MenuItem,
  CardContent,
  Card,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../../../api";
import moment from "moment";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/lab";
import { dateFnsFormat } from "../../../CalendarPage/constants/Calendar-constants";

import AdapterDateFns from "@mui/lab/AdapterDateFns";

export default function BlockRoom({
  singleSpaceInfo,
  fetchBookingData,
  hotelId,
  onClose,
}) {
  const checkInOutSlots = Array.from({ length: 24 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );
  const [spaceRooms, setSpaceRooms] = useState([]);
  const [checkinDate, setcheckinDate] = useState(new Date());
  const [checkoutDate, setcheckoutDate] = useState(new Date());
  const [checkinTime, setcheckinTime] = useState("09");
  const [checkoutTime, setcheckoutTime] = useState("10");
  const [reason, setReason] = useState("");
  const [spaceIds, setSpaceIds] = useState({});
  const [calculatedPrice, setCalculatedPrice] = useState({});
  const [spaceAvailability, setSpaceAvailability] = useState({});
  const [numPeople, setNumPeople] = useState(1);
  const [loader, setloader] = useState(false);

  //   check-space-availability
  //   useEffect(() => {
  //     if (spaceIds?.id) {
  //       const payload = {
  //         hotelId: hotelId,
  //         checkin: moment(checkin).format("DD-MM-YYYY HH:mm:ss"),
  //         checkout: moment(checkout).format("DD-MM-YYYY HH:mm:ss"),
  //         spaceTypeId: singleSpaceInfo?.id,
  //         spaceIds: [spaceIds?.id],
  //       };
  //       handleSpringDataMutationRequest(
  //         "POST",
  //         `core/api/v1/non-rental-booking/check-space-availability`,
  //         payload
  //       )
  //         .then((res) => {
  //           setSpaceAvailability(res);
  //         })
  //         .catch(() => {});
  //     }
  //   }, [checkin, checkout, spaceIds]);

  //   calculate-price
  //   useEffect(() => {
  //     if (spaceIds?.id) {
  //       const payload = {
  //         nonRentalIds: [spaceIds?.id],
  //         checkinDateTime: moment(checkin).format("DD-MM-YYYY HH:mm:ss"),
  //         checkoutDateTime: moment(checkout).format("DD-MM-YYYY HH:mm:ss"),
  //         numberOfPersons: numPeople,
  //       };
  //       handleSpringDataMutationRequest(
  //         "POST",
  //         `core/api/v1/non-rental-booking/calculate-price`,
  //         payload
  //       )
  //         .then((res) => {
  //           setCalculatedPrice(res);
  //         })
  //         .catch(() => {});
  //     }
  //   }, [checkin, checkout, spaceIds, numPeople]);

  useEffect(() => {
    if (singleSpaceInfo?.id) {
      handleSpringDataRequest(
        `core/api/v1/non-rental/get-non-rental-by-type-id/?typeId=${singleSpaceInfo?.id}`
      )
        .then((res) => {
          setSpaceRooms(res);
          setSpaceIds(res[0]);
        })
        .catch((err) => {});
    }
  }, [singleSpaceInfo]);

  const handleBooking = () => {
    setloader(true);
    const payload = {
      hotelId: hotelId,
      checkin:
        moment(checkinDate).format("DD-MM-YYYY") + " " + `${checkinTime}:00:00`,
      checkout:
        moment(checkoutDate).format("DD-MM-YYYY") +
        " " +
        `${checkoutTime}:00:00`,
      source: "PMS",
      spaceTypeId: singleSpaceInfo?.id,
      spaceIds: [spaceIds?.id],
      blockReason: reason,
    };
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental-booking/block-space`,
      payload
    )
      .then(() => {
        setloader(false);
        fetchBookingData();
        onClose();
      })
      .catch(() => {
        setloader(false);
        onClose();
      });
  };

  return (
    <Box sx={{ width: 700, paddingX: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingY: 2,
        }}
      >
        <Typography sx={{ fontSize: 20, fontWeight: 500 }}>
          Block room
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Card sx={{ border: "1px solid #CCC", borderRadius: 2 }}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                  gutterBottom
                >
                  Check-in
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    inputFormat={dateFnsFormat}
                    label={"Check-in"}
                    disableMaskedInput
                    mask="___ ___, ____"
                    id="booking_start"
                    name="booking_start"
                    size="small"
                    minDate={new Date()}
                    value={checkinDate}
                    onChange={(newValue) => {
                      setcheckinDate(newValue);
                      if (checkoutDate && newValue && checkoutDate < newValue) {
                        setcheckoutDate(newValue);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} style={{ width: 305 }} />
                    )}
                  />
                </LocalizationProvider>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                  gutterBottom
                >
                  Check-out
                </Typography>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    id="booking_end"
                    mask="____ ___, ____"
                    disableMaskedInput
                    name="booking_end"
                    size="small"
                    minDate={checkinDate}
                    placeholder="Booking End Date"
                    label={"Checkout"}
                    variant="inline"
                    autoOk={true}
                    inputFormat={dateFnsFormat}
                    value={checkoutDate}
                    onChange={(newValue) => setcheckoutDate(newValue)}
                    renderInput={(params) => (
                      <TextField {...params} style={{ width: 305 }} />
                    )}
                  />
                </LocalizationProvider>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                  gutterBottom
                >
                  Check-in time
                </Typography>{" "}
                <TextField
                  select
                  size="small"
                  value={checkinTime}
                  onChange={(e) => {
                    setcheckinTime(e.target.value);
                    if (
                      checkinDate?.getDate() === checkoutDate?.getDate() &&
                      e.target.value >= checkoutTime
                    ) {
                      let cOutTime = (1 + +e.target.value)
                        .toString()
                        .padStart(2, "0");
                      setcheckoutTime(cOutTime);
                    }
                  }}
                  placeholder={"Check-in time"}
                  fullWidth
                  sx={{
                    "& legend": { display: "none" }, // remove notch
                  }}
                >
                  {checkInOutSlots.map((slot) => (
                    <MenuItem key={slot} value={slot}>
                      {`${slot > 12 ? slot - 12 : slot} ${
                        slot >= 12 ? "PM" : "AM"
                      }`}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                  gutterBottom
                >
                  Check-out time
                </Typography>
                <TextField
                  select
                  size="small"
                  value={checkoutTime}
                  onChange={(e) => {
                    setcheckoutTime(e.target.value);
                  }}
                  placeholder={"Check-out time"}
                  sx={{
                    "& legend": { display: "none" }, // remove notch
                  }}
                  fullWidth
                >
                  {checkInOutSlots.map((slot) => (
                    <MenuItem
                      key={slot}
                      value={slot}
                      disabled={
                        checkinDate?.getDate() === checkoutDate?.getDate() &&
                        slot <= checkinTime
                      }
                    >
                      {`${slot > 12 ? slot - 12 : slot} ${
                        slot >= 12 ? "PM" : "AM"
                      }`}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>
            {/* <Grid item xs={12}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                  gutterBottom
                >
                  Select room
                </Typography>
                <TextField
                  select
                  fullWidth
                  value={spaceIds}
                  onChange={(e) => setSpaceIds(e?.target?.value)}
                  size="small"
                  placeholder={"Select Space"}
                  sx={{
                    "& legend": { display: "none" },
                  }}
                >
                  {spaceRooms.map((option) => (
                    <MenuItem key={option?.id} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid> */}
            <Grid item xs={12}>
              <TextField
                label="Reason for blocking"
                fullWidth
                multiline
                minRows={3}
                value={reason}
                onChange={(e) => setReason(e?.target?.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                fullWidth
                size="large"
                onClick={handleBooking}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#36454F",
                  color: "white",
                  borderColor: "#36454F",
                  "&:hover": {
                    backgroundColor: "#36454FDD",
                    borderColor: "#36454FDD",
                  },
                }}
                disabled={loader}
              >
                {loader ? (
                  <CircularProgress
                    size={15}
                    color="inherit"
                    sx={{ ml: 1.5 }}
                  />
                ) : (
                  `Block Now`
                )}
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}
